import { Box, Chip, Typography, useTheme } from "@mui/material";
import { Inventory2Outlined } from "@mui/icons-material";
import { tokens } from "../../../../theme";
import AnimatedTable, { ColumnDef } from "../AnimatedTable";
import type { IEquipment } from "../../../../types/equipment";

const mockComponents = [
  { id: 1, item: "Power Adapter", quantity: 1, status: "Available" },
  { id: 2, item: "Lense", quantity: 2, status: "Available" },
  { id: 3, item: "Tripod", quantity: 1, status: "Missing" },
];

interface Props {
  equipment: IEquipment;
}

export default function ComponentsTab({ equipment }: Props) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns: ColumnDef<(typeof mockComponents)[0]>[] = [
    {
      key: "item",
      label: "Item",
      cellSx: { fontWeight: 500, color: colors.primary[900] },
      render: (row) => row.item,
    },
    { key: "quantity", label: "Quantity", render: (row) => row.quantity },
    {
      key: "status",
      label: "Status",
      render: (row) => (
        <Chip
          label={row.status}
          size="small"
          sx={{
            bgcolor: row.status === "Available" ? "#e0f2f1" : "#ffebee",
            color: row.status === "Available" ? "#00695c" : "#c62828",
            fontWeight: 600,
            borderRadius: "16px",
          }}
        />
      ),
    },
  ];

  return (
    <Box>
      {!equipment.isKit ? (
        <Box
          sx={{ display: "grid", placeItems: "center", minHeight: 200, gap: 2 }}
        >
          <Box sx={{ textAlign: "center" }}>
            <Inventory2Outlined
              sx={{ fontSize: 48, color: theme.palette.text.secondary, mb: 1 }}
            />
            <Typography
              fontWeight={600}
              color={theme.palette.text.primary}
              mb={0.5}
            >
              This is a single item, not a kit.
            </Typography>
            <Typography variant="body2" color={theme.palette.text.secondary}>
              Enable &quot;kit&quot; mode in Edit to add components.
            </Typography>
          </Box>
        </Box>
      ) : (
        <AnimatedTable
          columns={columns}
          rows={mockComponents}
          getRowId={(row) => row.id}
          page={0}
          totalPages={1}
          onPageChange={() => {}}
          emptyMessage="No components found."
        />
      )}
    </Box>
  );
}
